import App from 'app/app.js';
import template from './customize-sheet-item.html';
import './customize-sheet-item.scss';

import sheet_1_8x10 from './sheet/sheet-1-8x10.js';
import sheet_2_5x7 from './sheet/sheet-2-5x7.js';
import sheet_4_3x5 from './sheet/sheet-4-3x5.js';
import sheet_8_2x3 from './sheet/sheet-8-2x3.js';
import sheet_18_1x2 from './sheet/sheet-18-1x2.js';
import sheet_2_3x5_4_2x3 from './sheet/sheet-2-3x5-4-2x3.js';
import sheet_1_3x5_2_2x3 from './sheet/sheet-1-3x5-2-2x3.js';
import sheet_1_3x5_4_1x2 from './sheet/sheet-1-3x5-4-1x2.js';
import sheet_1_5x7_1_3x5_2_2x3 from './sheet/sheet-1-5x7-1-3x5-2-2x3.js';
import sheet_1_5x7_2_3x5 from './sheet/sheet-1-5x7-2-3x5.js';
import sheet_1_5x7_4_2x3 from './sheet/sheet-1-5x7-4-2x3.js';
import sheet_1_5x7_9_1x2 from './sheet/sheet-1-5x7-9-1x2.js';
import sheet_2_3x5_8_1x2 from './sheet/sheet-2-3x5-8-1x2.js';
import sheet_2_3x5 from './sheet/sheet-2-3x5.js';
import sheet_4_2x3 from './sheet/sheet-4-2x3.js';
import sheet_8_1x2 from './sheet/sheet-8-1x2.js';
import sheet_2_2x3_4_1x2 from './sheet/sheet-2-2x3-4-1x2.js';
import sheet_2_3x5_4_2x3_Magnet from './sheet/sheet-2-3x5-4-2x3_Magnet.js';

class CustomizeItemController {
  // sub-pixel fix
  CELL_SCALE = 1.05;

  height = 64;

  SHEET_MAP = this.toSheetMap([
    sheet_1_8x10,
    sheet_2_5x7,
    sheet_4_3x5,
    sheet_8_2x3,
    sheet_18_1x2,
    sheet_2_3x5_4_2x3,
    sheet_1_3x5_2_2x3,
    sheet_1_3x5_4_1x2,
    sheet_1_5x7_1_3x5_2_2x3,
    sheet_1_5x7_2_3x5,
    sheet_1_5x7_4_2x3,
    sheet_1_5x7_9_1x2,
    sheet_2_3x5_8_1x2,
    sheet_2_3x5,
    sheet_4_2x3,
    sheet_8_1x2,
    sheet_2_2x3_4_1x2,
    sheet_2_3x5_4_2x3_Magnet
  ]);

  template = null;

  $onInit() {
    const sheetKey = this.getSheetKey(this.displayGroup, this.imageCount);

    const sheet = this.SHEET_MAP[sheetKey] || sheet_1_8x10;

    this.template = sheet.calc(this.height);
  }

  toSheetMap(sheets) {
    return sheets.reduce((acc, sheet) => {
      const sheetKey = this.getSheetKey(sheet.displayGroup, sheet.imageCount);

      acc[sheetKey] = sheet;

      return acc;
    }, {});
  }

  getSheetKey(displayGroup, imageCount) {
    return `${displayGroup}_${imageCount}`;
  }

  getOrientation() {
    return this.look.orientation.toUpperCase();
  }
}

App.component('ltCustomSheetItem', {
  template,
  bindings: {
    displayGroup: '<',
    imageCount: '<',
    look: '<',
    bearerTokenUrl: '<'
  },
  controller: CustomizeItemController,
  controllerAs: '$ctrl'
});
